// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    /* Greif Custom Code - Start */
    color: "#09f",
    style: "solid",
    width: "2px",
    /* Greif Custom Code - End */
};

export default focus;
